import { Button, Container, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { TextBox } from "../../components";
import { config } from "../../config";
import { AlertContext } from "../../contexts";
import { NetworkCall } from "../../networkcall";
import {
  AlertProps,
  NetWorkCallMethods,
  ValidateEmail
} from "../../utils";
import { withNamespaces } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  root: {
    // textAlign: "center",
    // marginTop: "10%"
  },
  btn: {
    padding: "7px",
    borderRadius: theme.palette.borderRadius,
    boxShadow: "opx 6px 10px #00000014",
    marginTop: 30,
    height: "48px",
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: "#5078E1",
    },
  },
}));

const InitialState = {
  email: "",
  error: {
    email: "",
  },
};

const ForgetPassword = (props) => {
  const {t = () => false} = props
  const classes = useStyles();
  const [forgetMail, setForgetMail] = React.useState({ ...InitialState });
  const alert = React.useContext(AlertContext);
  const updateState = (key, value) => {
    if (key === "email") {
      ValidateEmail(value);
    }
    let error = forgetMail.error;
    error[key] = "";
    setForgetMail({ ...forgetMail, [key]: value, error });
  };
  const isIamValideToforgetMail = () => {
    let isValid = true;
    let error = forgetMail.error;
    // Checking Email
    if (forgetMail.email.length === 0) {
      isValid = false;
      error.email = t("Email is required");
    }
    setForgetMail({ ...forgetMail, error });
    return isValid;
  };
  const onSendforgetMailBtnClicked = () => {
    if (isIamValideToforgetMail()) {
      const data = {
        email_id: forgetMail.email?.toLowerCase(),
      };

      NetworkCall(
        `${config.auth_api_url}/auth/forgotpassword`,
        NetWorkCallMethods.post,
        data,
        null,
        false,
        false
      )
        .then((response) => {
          if (response.status === 200) {
            alert.setSnack({
              ...alert,
              open: true,
              severity: AlertProps.severity.success,
              msg: t("Passwordresetemailsentsuccessfully"),
            });
            props.onDrawerClose();
          }
        })
        .catch((err) => {
          alert.setSnack({
            ...alert,
            open: true,
            severity: AlertProps.severity.error,
            msg: t("InvalidEmailID"),
          });
        });

    } else {
      return false;
    }
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="sm">
        <Grid container>
          <Grid item xs={12}>
            <TextBox
              label={t("RegisteredEmailID")}
              placeholder={t("EnterRegisteredEmailID")}
              value={forgetMail.email}
              isError={forgetMail.error.email.length > 0}
              errorMessage={forgetMail.error.email}
              onChange={(e) => updateState("email", e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <br />

            <Button
              fullWidth
              variant="contained"
              className={classes.btn}
              onClick={onSendforgetMailBtnClicked}
            >
              {t("Submit")}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default withNamespaces("welcomePage")(ForgetPassword)